/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function () {

  // check if the second option (32 single serve cups) is checked on load of the document
  let isChecked = $('input[name="size-b"]')[1].checked;

  // if it is, then we need to hide the grind size immediately
  if (isChecked) {
    // Hide the grind size dropdown entirely
    $('#grind-size-selector').hide();
  }

  // then, just listen for changes to the "size-b" inputs, which are the buttons for the Size
  // variants on the page. They appear as buttons but are actually hidden radios in the html
  $(document).on('change', 'input[name="size-b"]', function (e) {
    if (e.target.value === '32 single serve cups') {
      // set or remove any name value for Grind Size dropdown
      $('#grind-size').attr('name', '');
      // Hide the grind size dropdown entirely
      $('#grind-size-selector').hide();
    } else {
      // Add the Name attribute that will make it show up as a line item property
      $('#grind-size').attr('name', 'properties[Grind Size]');
      // Show the grind size selector again
      $('#grind-size-selector').show();
    }
  });
});
